// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $PromotionalItemInput = (tag, _1) => ({tag, _1});
const selectionIsSymbol = {reflectSymbol: () => "selection"};
const FreeProductInputIsSymbol = {reflectSymbol: () => "FreeProductInput"};
const NoInputIsSymbol = {reflectSymbol: () => "NoInput"};
const productGroupIndexIsSymbol = {reflectSymbol: () => "productGroupIndex"};
const productSequenceNumIsSymbol = {reflectSymbol: () => "productSequenceNum"};
const ProductReferenceIsSymbol = {reflectSymbol: () => "ProductReference"};
const activeIsSymbol = {reflectSymbol: () => "active"};
const assignmentIsSymbol = {reflectSymbol: () => "assignment"};
const inputIsSymbol = {reflectSymbol: () => "input"};
const promotionIdIsSymbol = {reflectSymbol: () => "promotionId"};
const promotionalItemIdIsSymbol = {reflectSymbol: () => "promotionalItemId"};
const sourceIsSymbol = {reflectSymbol: () => "source"};
const valueIsSymbol = {reflectSymbol: () => "value"};
const PromotionalItemIsSymbol = {reflectSymbol: () => "PromotionalItem"};
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode};
const FreeProductInput = value0 => $PromotionalItemInput("FreeProductInput", value0);
const NoInput = /* #__PURE__ */ $PromotionalItemInput("NoInput");
const ProductReference = x => x;
const PromotionalItem = x => x;
const newtypePromotionalItem_ = {Coercible0: () => {}};
const newtypeProductReference_ = {Coercible0: () => {}};
const hasFieldPromotionalItem = dictHasField => dictHasField;
const hasFieldProductReference = dictHasField => dictHasField;
const eqPromotionalItemInput = {
  eq: x => y => {
    if (x.tag === "FreeProductInput") {
      if (y.tag === "FreeProductInput") { return x._1.selection === y._1.selection; }
      return false;
    }
    if (x.tag === "NoInput") { return y.tag === "NoInput"; }
    return false;
  }
};
const eqProductReference = {eq: x => y => x.productGroupIndex === y.productGroupIndex && x.productSequenceNum === y.productSequenceNum};
const eq7 = /* #__PURE__ */ (() => Data$dEq.eqArrayImpl(eqProductReference.eq))();
const eqPromotionalItem = {
  eq: x => y => x.active === y.active && (() => {
    if (x.assignment.tag === "Nothing") { return y.assignment.tag === "Nothing"; }
    if (x.assignment.tag === "Just") {
      if (y.assignment.tag === "Just") {
        return x.assignment._1.productGroupIndex === y.assignment._1.productGroupIndex && x.assignment._1.productSequenceNum === y.assignment._1.productSequenceNum;
      }
      return false;
    }
    return false;
  })() && (() => {
    if (x.input.tag === "FreeProductInput") {
      if (y.input.tag === "FreeProductInput") { return x.input._1.selection === y.input._1.selection; }
      return false;
    }
    if (x.input.tag === "NoInput") { return y.input.tag === "NoInput"; }
    return false;
  })() && x.promotionId === y.promotionId && x.promotionalItemId === y.promotionalItemId && eq7(x.source)(y.source) && (() => {
    if (x.value.tag === "Nothing") { return y.value.tag === "Nothing"; }
    if (x.value.tag === "Just") {
      if (y.value.tag === "Just") { return x.value._1 === y.value._1; }
      return false;
    }
    return false;
  })()
};
const genericPromotionalItemInput = {
  to: x => {
    if (x.tag === "Inl") { return $PromotionalItemInput("FreeProductInput", x._1); }
    if (x.tag === "Inr") { return NoInput; }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "FreeProductInput") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "NoInput") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments); }
    $runtime.fail();
  }
};
const showPromotionalItemInput = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["{ selection: " + Data$dShow.showStringImpl(v.selection) + " }"]})(FreeProductInputIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(NoInputIsSymbol);
    return x => {
      if (x.tag === "FreeProductInput") { return $0["genericShow'"](x._1); }
      if (x.tag === "NoInput") { return $1["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodePromotionalItemInput = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(FreeProductInputIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(selectionIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(NoInputIsSymbol)))(Unscramble$dGeneric.defaultOptions);
    return x => {
      const $1 = $0(x);
      if ($1.tag === "Inl") { return $PromotionalItemInput("FreeProductInput", $1._1); }
      if ($1.tag === "Inr") { return NoInput; }
      $runtime.fail();
    };
  })()
};
const genericPromotionalItem = {to: x => x, from: x => x};
const genericProductReference = {to: x => x, from: x => x};
const showProductReference = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ productGroupIndex: " + Data$dShow.showIntImpl(v.productGroupIndex) + ", productSequenceNum: " + Data$dShow.showIntImpl(v.productSequenceNum) + " " + "}"
      ]
    })(ProductReferenceIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const showPromotionalItem = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(showProductReference.show);
      return {
        genericShowArgs: v => [
          (() => {
            if (v.active) {
              if (v.assignment.tag === "Just") {
                return "{ active: true, assignment: (Just " + showProductReference.show(v.assignment._1) + ")" + ", input: " + showPromotionalItemInput.show(v.input) + ", promotionId: " + Data$dShow.showIntImpl(v.promotionId) + ", promotionalItemId: " + Data$dShow.showIntImpl(v.promotionalItemId) + ", source: " + $0(v.source) + (() => {
                  if (v.value.tag === "Just") { return ", value: (Just " + Data$dMoney$dRounded.toString(v.value._1) + ") "; }
                  if (v.value.tag === "Nothing") { return ", value: Nothing "; }
                  $runtime.fail();
                })() + "}";
              }
              if (v.assignment.tag === "Nothing") {
                return "{ active: true, assignment: Nothing, input: " + showPromotionalItemInput.show(v.input) + ", promotionId: " + Data$dShow.showIntImpl(v.promotionId) + ", promotionalItemId: " + Data$dShow.showIntImpl(v.promotionalItemId) + ", source: " + $0(v.source) + (() => {
                  if (v.value.tag === "Just") { return ", value: (Just " + Data$dMoney$dRounded.toString(v.value._1) + ") "; }
                  if (v.value.tag === "Nothing") { return ", value: Nothing "; }
                  $runtime.fail();
                })() + "}";
              }
              $runtime.fail();
            }
            if (v.assignment.tag === "Just") {
              return "{ active: false, assignment: (Just " + showProductReference.show(v.assignment._1) + ")" + ", input: " + showPromotionalItemInput.show(v.input) + ", promotionId: " + Data$dShow.showIntImpl(v.promotionId) + ", promotionalItemId: " + Data$dShow.showIntImpl(v.promotionalItemId) + ", source: " + $0(v.source) + (() => {
                if (v.value.tag === "Just") { return ", value: (Just " + Data$dMoney$dRounded.toString(v.value._1) + ") "; }
                if (v.value.tag === "Nothing") { return ", value: Nothing "; }
                $runtime.fail();
              })() + "}";
            }
            if (v.assignment.tag === "Nothing") {
              return "{ active: false, assignment: Nothing, input: " + showPromotionalItemInput.show(v.input) + ", promotionId: " + Data$dShow.showIntImpl(v.promotionId) + ", promotionalItemId: " + Data$dShow.showIntImpl(v.promotionalItemId) + ", source: " + $0(v.source) + (() => {
                if (v.value.tag === "Just") { return ", value: (Just " + Data$dMoney$dRounded.toString(v.value._1) + ") "; }
                if (v.value.tag === "Nothing") { return ", value: Nothing "; }
                $runtime.fail();
              })() + "}";
            }
            $runtime.fail();
          })()
        ]
      };
    })())(PromotionalItemIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeProductReference = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(productGroupIndexIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(productSequenceNumIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodePromotionalItem = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(activeIsSymbol)(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons(assignmentIsSymbol)(Unscramble.decodeMaybe(unscrambleDecodeProductReference))(Unscramble.decodeRecordCons(inputIsSymbol)(unscrambleDecodePromotionalItemInput)(Unscramble.decodeRecordCons(promotionIdIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(promotionalItemIdIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(sourceIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(unscrambleDecodeProductReference.unsafeDecode)
    })(Unscramble.decodeRecordCons(valueIsSymbol)(Unscramble.decodeMaybe(Data$dMoney$dRounded.udecodeMoney))(Unscramble.decodeRecordNil))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodePromotionalItemInput = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericPromotionalItemInput)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(FreeProductInputIsSymbol)((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(selectionIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(NoInputIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        $runtime.fail();
      }
    };
  })())
};
const encodeProductReference = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericProductReference)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ProductReferenceIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(productSequenceNumIsSymbol)(encodeWithOptionsOther))(productGroupIndexIsSymbol)(encodeWithOptionsOther);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodePromotionalItem = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericPromotionalItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(PromotionalItemIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(valueIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Data$dInt.toNumber(v2._1) / 100.0; }
        $runtime.fail();
      }
    }))(sourceIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(encodeProductReference.encode);
      return {encodeWithOptions: v => encode1};
    })()))(promotionalItemIdIsSymbol)(encodeWithOptionsOther))(promotionIdIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))(inputIsSymbol)({
      encodeWithOptions: v => encodePromotionalItemInput.encode
    }))(assignmentIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return encodeProductReference.encode(v2._1); }
        $runtime.fail();
      }
    }))(activeIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodePromotionalItemInput = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericPromotionalItemInput)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(FreeProductInputIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(selectionIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.readString
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(NoInputIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments)))
};
const decodeProductReference = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericProductReference)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ProductReferenceIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(productSequenceNumIsSymbol)(decodeWithOptionsOther)())(productGroupIndexIsSymbol)(decodeWithOptionsOther)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodePromotionalItem = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericPromotionalItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PromotionalItemIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(valueIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dMoney$dRounded.decodeMoney.decode)
  })())(sourceIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(decodeProductReference).decode;
    return {decodeWithOptions: v => decode2};
  })())())(promotionalItemIdIsSymbol)(decodeWithOptionsOther)())(promotionIdIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode})())(inputIsSymbol)({
    decodeWithOptions: v => decodePromotionalItemInput.decode
  })())(assignmentIsSymbol)({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(decodeProductReference.decode)})())(activeIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.booleanDecode.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  $PromotionalItemInput,
  FreeProductInput,
  FreeProductInputIsSymbol,
  NoInput,
  NoInputIsSymbol,
  ProductReference,
  ProductReferenceIsSymbol,
  PromotionalItem,
  PromotionalItemIsSymbol,
  activeIsSymbol,
  assignmentIsSymbol,
  decodeProductReference,
  decodePromotionalItem,
  decodePromotionalItemInput,
  decodeWithOptionsOther,
  encodeProductReference,
  encodePromotionalItem,
  encodePromotionalItemInput,
  encodeWithOptionsOther,
  eq7,
  eqProductReference,
  eqPromotionalItem,
  eqPromotionalItemInput,
  genericProductReference,
  genericPromotionalItem,
  genericPromotionalItemInput,
  hasFieldProductReference,
  hasFieldPromotionalItem,
  inputIsSymbol,
  newtypeProductReference_,
  newtypePromotionalItem_,
  productGroupIndexIsSymbol,
  productSequenceNumIsSymbol,
  promotionIdIsSymbol,
  promotionalItemIdIsSymbol,
  selectionIsSymbol,
  showProductReference,
  showPromotionalItem,
  showPromotionalItemInput,
  sourceIsSymbol,
  unscrambleDecodeProductReference,
  unscrambleDecodePromotionalItem,
  unscrambleDecodePromotionalItemInput,
  valueIsSymbol
};
